import { inject, Injectable, signal } from "@angular/core";
import { catchError, map, Observable, of, switchMap, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";

import {
  LiquidViewerConfiguration,
  LiquidViewerMainContent,
  LiquidViewerPageSettings,
  LiquidViewerToolbarConfiguration,
} from "../liquid-viewer.models";
import {
  environment,
} from "src/index";
import {
  LiquidViewerConverterService,
  LiquidViewerIndexService,
  LiquidViewerAnnotationListService,
} from "src/index/services.index";

@Injectable({
  providedIn: 'root'
})
export class LiquidViewerService {

  httpClient = inject(HttpClient);
  liquidViewerConverterService = inject(LiquidViewerConverterService);
  liquidViewerIndexService = inject(LiquidViewerIndexService);
  liquidViewerAnnotationsListService = inject(LiquidViewerAnnotationListService);

  $toolbarConfig = signal<Partial<LiquidViewerToolbarConfiguration>>({
    position: 'left',
    floating: false,
  });
  $viewerConfig = signal<Partial<LiquidViewerConfiguration>>({
    showProgressBar: true,
  });
  $pageSettings = signal<Partial<LiquidViewerPageSettings>>({
    orientation: 'vertical',
    margins: 'normal'
  });

  getMainContent(mainId: string) {
    if (environment.courseDetail) {
      return this.httpClient.get<any>(
        environment.courseDetail.replace(':uuidCourse', mainId)
      ).pipe(
        catchError(() => of(undefined)),
        map(data => this.liquidViewerConverterService.convertMainContent(data)),
        switchMap((data) => this.liquidViewerAnnotationsListService.loadAnnotations(mainId).pipe(
          map(annotations => ({
            ...data,
            index: this.liquidViewerIndexService.prepareIndex(data.index),
            annotations,
          }))
        )),
      );
    }
    return of(undefined);
  }

  getPageContent(mainId: string, secondaryId: string, contentId: string): Observable<any | undefined> {
    if (environment.courseModuleContent) {
      return this.httpClient.get<any>(
        environment.courseModuleContent
          .replace(':courseId', mainId)
          .replace(':moduleId', secondaryId)
          .replace(':contentId', contentId)
      ).pipe(
        catchError(() => of(undefined)),
        map(data => this.liquidViewerConverterService.convertPageContent(data)),
        tap(() => this.liquidViewerIndexService.$currentIndexItemId.set(contentId)),
      );
    }
    return of(undefined);
  }
}
